/**
 * Parses version number from a filename like:
 * Firmware_OMEGA_sigenc_v0.11.68.tar  =>  0.11.68
 * Firmware_OMEGA_dev_v0.10.10.tar.gz  =>  0.10.10
 */
export function parseVersionFromFilename(fwFilename: string) {
    return (fwFilename?.match(/_v(.+)\.tar(\.gz)?$/) || [])[1];
}
